var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.displayMessage,
      expression: "displayMessage"
    }],
    class: [_vm.className, {
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "disabled": _vm.isDisabled && !_vm.isLoading,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayMessage) ? _vm._i(_vm.displayMessage, null) > -1 : _vm.displayMessage
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "change": function change($event) {
        var $$a = _vm.displayMessage,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayMessage = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.displayMessage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.displayMessage = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.displayMessage,
      expression: "displayMessage"
    }],
    class: [_vm.className, {
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "disabled": _vm.isDisabled && !_vm.isLoading,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.displayMessage, null)
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "change": function change($event) {
        _vm.displayMessage = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.displayMessage,
      expression: "displayMessage"
    }],
    class: [_vm.className, {
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "disabled": _vm.isDisabled && !_vm.isLoading,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.displayMessage
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.displayMessage = $event.target.value;
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }